export const IMAGE_ENDPOINT = {
  IMAGE: 'Images',
  UPLOAD_SCENE_IMAGE: 'Images/UploadScene',
  GET_PROCESSED_IMAGES: 'Images/ProcessedImages',
};

export const IMAGES_SIZE = {
  size2048: 'size2048',
};
